import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__$1 from '../SdsContentLoader/SdsContentLoader.vue.js';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';

var script = defineComponent({
    name: 'SdsButtonIcon',
    props: {
        type: {
            type: String,
            default: 'button',
        },
        background: {
            type: String,
            default: 'elevation',
        },
        variant: {
            type: String,
            default: 'primary',
        },
        size: {
            type: String,
            default: 'lg',
        },
        hasContainer: {
            type: Boolean,
            default: true,
        },
        iconName: {
            type: String,
            required: true,
        },
        isIconThemed: {
            type: Boolean,
            default: false,
        },
        isThemed: {
            type: Boolean,
            default: false,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['click'],
    setup: function (props, _a) {
        var emit = _a.emit;
        var contentLoaderSize = computed(function () {
            switch (props.size) {
                case 'lg':
                    return 'md';
                case 'md':
                    return 'sm';
                case 'sm':
                    return 'xs';
                default:
                    return '';
            }
        });
        function onClick(event) {
            if (props.isDisabled || props.isLoading) {
                event.preventDefault();
                event.stopPropagation();
            }
            emit('click', event);
        }
        return {
            contentLoaderSize: contentLoaderSize,
            onClick: onClick,
        };
    },
    components: {
        SdsIcon: __vue_component__,
        SdsContentLoader: __vue_component__$1,
    },
});

export default script;
